import fetchWithCSRF from "@core/scripts/helper/fetch-with-csrf";
import URL from "@core/scripts/helper/url";
import Logger from "@core/scripts/components/logger";

export default function deleteCoupon(onSuccess, onFailure) {
    fetchWithCSRF(URL.toAbsolute('/buy/coupons/'), {
        method: 'DELETE',
        headers: new Headers({
            'Content-Type': 'application/json'
        })
    })
    .then(async response => {
        if (!response.ok) {
            return onFailure();
        }
        const data = await response.json();
        return onSuccess(data);
    })
    .catch((error) => {
        Logger.error('deleting coupon failed.', error);
        onFailure(error);
    });
}
